// extracted by mini-css-extract-plugin
export var content = "_q2-1";
export var fullScreen = "_q2-0";